import _ from 'lodash';
import { ValidationRule, ValidationResult, Value } from '@cnamts/vue-dot/src/rules/types';

const defaultErrorMessages = {
	default: 'La saisie est obligatoire.'
};

export function hasTextLength(numberOne: number, errorMessages = defaultErrorMessages): ValidationRule<Value> {
	return (value: Value): ValidationResult => {
		if (_.isNull(value)) {
			return true;
		}

		return _.trim(value).length === numberOne || errorMessages.default;
	};
}

export function hasTextTwoLength(
	numberOne: number, numberTwo: number, errorMessages = defaultErrorMessages): ValidationRule<Value> {
	return (value: Value): ValidationResult => {
		if (_.isNull(value)) {
			return true;
		}

		return (_.trim(value).length === numberOne || _.trim(value).length === numberTwo) || errorMessages.default;
	};
}

export function hasTextThreeLength(
	numberOne: number, numberTwo: number, numberThree: number,
	errorMessages = defaultErrorMessages): ValidationRule<Value> {
	return (value: Value): ValidationResult => {
		if (_.isNull(value)) {
			return true;
		}

		return (_.trim(value).length === numberOne
			|| _.trim(value).length === numberTwo
			|| _.trim(value).length === numberThree)
			|| errorMessages.default;
	};
}
